module.exports = __webpack_public_path__ + "static/img/hotwindImg3.ed9e6d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hotwindImg3.png
// module id = Ys1F
// module chunks = 2